/**
 * Quote WhatsApp follow-up automation (scheduled messages after quote send).
 * Backend: GET/POST .../quotes/followup-automation/...
 */

import api from "../../../shared/api.jsx";

/**
 * @param {string} quoteId
 * @returns {Promise<{ success: boolean, data?: object, notFound?: boolean, error?: string }>}
 */
export async function getQuoteFollowUpAutomation(quoteId) {
  if (!quoteId) {
    return { success: false, error: "quoteId required" };
  }
  try {
    const encoded = encodeURIComponent(quoteId);
    const res = await api.get(`/quotes/followup-automation/${encoded}`);
    return { success: true, data: res.data };
  } catch (e) {
    if (e?.status === 404) {
      return { success: true, data: null, notFound: true };
    }
    return {
      success: false,
      error: e?.message || "Failed to load automation",
    };
  }
}

export async function pauseQuoteFollowUpAutomation(quoteId, body = {}) {
  try {
    const encoded = encodeURIComponent(quoteId);
    const res = await api.post(
      `/quotes/followup-automation/${encoded}/pause`,
      body
    );
    return { success: true, data: res.data };
  } catch (e) {
    return { success: false, error: e?.message || "Pause failed" };
  }
}

export async function resumeQuoteFollowUpAutomation(quoteId, body = {}) {
  try {
    const encoded = encodeURIComponent(quoteId);
    const res = await api.post(
      `/quotes/followup-automation/${encoded}/resume`,
      body
    );
    return { success: true, data: res.data };
  } catch (e) {
    return { success: false, error: e?.message || "Resume failed" };
  }
}

export async function cancelQuoteFollowUpAutomation(quoteId, body = {}) {
  try {
    const encoded = encodeURIComponent(quoteId);
    const res = await api.post(
      `/quotes/followup-automation/${encoded}/cancel`,
      body
    );
    return { success: true, data: res.data };
  } catch (e) {
    return { success: false, error: e?.message || "Cancel failed" };
  }
}

/**
 * @param {string} quoteId
 * @param {string} scheduledFor ISO or parseable date string
 */
export async function rescheduleNextQuoteFollowUp(quoteId, scheduledFor) {
  try {
    const encoded = encodeURIComponent(quoteId);
    const res = await api.post(
      `/quotes/followup-automation/${encoded}/reschedule-next`,
      { scheduledFor }
    );
    return { success: true, data: res.data, jobId: res.jobId };
  } catch (e) {
    return { success: false, error: e?.message || "Reschedule failed" };
  }
}
